<template>
  <div class="Login">
    <div class="toLogin" @click="toRouter('/gongmao')">账号登录</div>
    <div class="LoginMethod">
      <div class="Method fl highlight">手机号注册<span></span></div>
      <div class="clear"></div>
    </div>
    <div class="EditingArea">
      <div class="vanField">
        <ul>
          <li>
            <van-field
              v-model="phone"
              maxlength="11"
              center
              clearable
              :border="false"
              use-button-slot
              placeholder="请输入手机号"
            />
          </li>
          <li class="authcodeInputWrapper">
            <van-field
              v-model="Verification"
              maxlength="6"
              class="VerificationStyle fl"
              clearable
              placeholder="请输入验证码"
              :border="false"
            />

            <div
              class="getVerificationStyle fr"
              @click="postAccountGetAuthCode"
              :style="{ color: Countdown1 > 0 ? '#BBBBBB' : '#333333' }"
            >
              {{ VerificationStatus }}
            </div>

            <div class="clear"></div>
          </li>
          <li class="selectIdentity">
            <!-- 选择身份 -->
            <van-field
              v-model="identity"
              readonly
              is-link
              :border="false"
              @click="showIdentity = true"
              placeholder="请选择身份"
            />
            <van-popup v-model="showIdentity" round position="bottom">
              <van-cascader
                v-model="cascaderValue"
                title="请选择身份"
                :options="identityList"
                @close="showIdentity = false"
                @finish="onSelectIdentity"
                active-color="#1972ff"
              />
            </van-popup>
          </li>
        </ul>
      </div>
    </div>
    <div class="OperatingSpace">
      <div class="protocolStyle">
        <van-checkbox
          class="fl"
          v-model="protocol"
          label-disabled
        ></van-checkbox>
        <span class="fl" @click="ClearanceAgreement">我同意</span>
        <a class="fl" @click="goPage('service-agreement')">《用户协议》</a>
        <span class="fl">及</span>
        <a class="fl" @click="goPage('privacy')">《法律声明及隐私政策》</a>
        <div class="clear"></div>
      </div>
      <van-button
        round
        type="info"
        @click="toRegist"
        :class="phone && protocol ? 'van-button--info' : 'noneVanButton'"
        >注册</van-button
      >
    </div>
  </div>
</template>
<script>
import { isPhone } from "../../../utils/validate";
import { identityList } from "./assets/gm_data";
export default {
  name: "registered",
  data() {
    return {
      showIdentity: false,
      identity: "",
      cascaderValue: "",
      identityList,
      protocol: true,
      phone: null,
      Verification: null,
      Countdown1: 0,
      branchId: "", // 机构id
      userFirstIdentity: "", //一级身份
      userIdentity: "", //二级身份
      yingjiGmBranchUcodeObj: {
        //应急山东省branchucode
        fat: "6cb2d6910c494d3f93a93d13c8a92700",
        uat: "bfca586d2ca04de3b3f670fa33e931ac",
        prod: "e17c634bc0eb40e4a86c896f51c5ddd9",
      },
    };
  },
  computed: {
    VerificationStatus() {
      if (this.Countdown1) {
        return `重新获取 ${this.Countdown1}s`;
      } else {
        return "发送验证码";
      }
    },
    yingjiBranchUcode() {
      //应急山东省branchucode
      let envArr = ["fat", "uat"];
      let env = "prod";
      envArr.forEach((d) => {
        if (window.location.hostname.includes(d)) {
          env = d;
        }
      });
      return this.yingjiGmBranchUcodeObj[env];
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (localStorage.getItem("token")) {
        vm.$router.replace("/");
      }
    });
  },
  created() {
    this.branchId = this.$route.query.branchId;
  },
  mounted() {},
  methods: {
    onSelectIdentity({ selectedOptions }) {
      this.showIdentity = false;
      this.identity = selectedOptions.map((option) => option.text).join("/");
      this.userFirstIdentity = selectedOptions[0].value;
      this.userIdentity = selectedOptions[1].value;
    },
    goPage(url) {
      this.$router.push(url);
    },
    async toRegist() {
      if (this.userFirstIdentity == "" || this.userIdentity == "") {
        this.$toast({
          message: "请选择身份",
        });
        return;
      }

      if (!this.protocol) return;
      const data = {
        account: this.phone,
        authCode: this.Verification,
        branchId: this.branchId,
        userFirstIdentity: this.userFirstIdentity,
        userIdentity: this.userIdentity,
      };
      let res = await this.$api.sdyjGmUser.register2Branch(data);
      if (res.success) {
        this.$toast({
          message: "恭喜你，注册成功",
        });
        localStorage.setItem("token", res.data);
        this.toLogin();
      }
    },
    getUserInfo() {
      this.$api.usercenter.getAccountUserInfo({}).then((res) => {
        localStorage.setItem("WDuserInfo", JSON.stringify(res.data));
        this.$store.commit("setUserInfo", res.data);
      });
    },
    // 查询用户id
    findUserId() {
      this.$api.usercenter.findUser().then((res) => {
        if (res.code == 0) {
          let subUser = { id: res.data.id };
          localStorage.setItem("subUserInfo", JSON.stringify(subUser));
        }
      });
    },
    async toLogin() {
      let branchRes = [];
      try {
        branchRes = await this.$api.account.getFindUserBranchList({});
      } catch (error) {
        if (error) {
          localStorage.removeItem('token')
          return
        }
      }
      // const branchRes =  await this.$api.account.getFindUserBranchList({});
      if (branchRes.data && branchRes.data.length) {
        let currentBranch = branchRes.data.find((item) => {
          return item.branchUcode === this.yingjiBranchUcode;
        });
        if (!currentBranch) {
          this.$notify({
            type: "warning",
            message: "暂未加入到当前机构！",
          });
          localStorage.removeItem('token')
          return;
        }

        localStorage.setItem("code", currentBranch.code);
        localStorage.setItem("organ", currentBranch.organ);
        localStorage.setItem("actor", currentBranch.actor);
        localStorage.setItem("branch", currentBranch.branch);
        currentBranch.channel &&
          localStorage.setItem("channel", currentBranch.channel);
        this.$sensors.login(currentBranch.code);
      }else {
        localStorage.removeItem('token')
        return
      }

      // 获取用户信息
      this.getUserInfo();
      // 获取用户id
      this.findUserId();

      this.$router.push("/gongmao");
    },
    toRouter(path) {
      this.$router.push({ path });
    },
    ClearanceAgreement() {
      this.protocol = !this.protocol;
    },
    setCountdown1() {
      let Countdown = null;
      Countdown = setInterval(() => {
        this.Countdown1--;
        if (this.Countdown1 <= 0) {
          clearInterval(Countdown);
        }
      }, 1000);
    },
    postAccountGetAuthCode() {
      if (this.Countdown1 > 0) return;
      if (isPhone.test(this.phone)) {
        this.Countdown1 = 60;
        this.setCountdown1();
        this.getAuthCode();
      } else {
        this.$notify({
          type: "warning",
          message: "手机号格式有误,请检查一下吧",
        });
      }
    },
    getAuthCode() {
      let data = { account: this.phone, type: 2 };
      this.$sensors.track("UM_Click_Verification_Code_Button");
      this.$api.usercenter.getAuthCodeCommon({ data });
    },
  },
};
</script>
<style lang="stylus" scoped>
.Login {
  background-color: #FFFFFF;
  min-height: 100vh;
}

.toLogin {
  padding-right: 24px;
  height: 100px;
  line-height: 100px;
  text-align: right;
  font-size: 30px;
  color: #333;
}

.LoginMethod {
  padding-left: 32px;
  padding-top: 22px;

  .Method {
    padding: 0 32px;
    font-size: 44px;
    font-weight: 900;
    color: #BBBBBB;
    position: relative;

    span {
      width: 48px;
      height: 8px;
      display: inline-block;
      background-color: #3660FF;
      border-radius: 4px;
      position: absolute;
      margin-left: -24px;
      bottom: -24px;
      left: 50%;
    }

    &.highlight {
      color: #333333;
    }
  }
}

.EditingArea {
  width: 622px;
  padding-top: 55px;
  position: relative;
  margin-left: -311px;
  left: 50%;

  li {
    padding: 1px 0;
    height: 122px;
    overflow: hidden;
    border-bottom: 1px solid #D7D7D7;
  }

  li.authcodeInputWrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  li.selectIdentity {
    .van-cell {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  .van-cell {
    padding: 0;
    height: 58px;
    line-height: 58px;
    font-size: 18px;
    background: transparent;
  }
}

.OperatingSpace {
  width: 622px;
  position: relative;
  margin-left: -311px;
  left: 50%;

  .van-button {
    width: 100%;
    height: 44px;
    line-height: 44px;
    margin-top: 32px;
    margin-bottom: 24px;

    span {
      color: #FFFFFF;
      font-size: 16px;
    }
  }

  .noneVanButton {
    background-color: #C0D5FF;
    border: 1px solid #C0D5FF;
  }

  .van-button--info {
    background-color: linear-gradient(136deg, #227FFF 0%, #316FFF 100%);
    border: 1px solid linear-gradient(136deg, #227FFF 0%, #316FFF 100%);
  }

  .protocolStyle {
    margin-top: 48px;

    .van-checkbox {
      margin-right: 16px;
    }

    span, a {
      display: inline-block;
      font-size: 26px;
      line-height: 30px;
      margin-top: 6px;
    }

    span {
      color: #666666;
    }

    a {
      color: #3760FF;
    }
  }
}

.VerificationStyle {
  width: 420px;
}

.getVerificationStyle {
  color: #333333;
  font-size: 30px;
}
</style>
